
import api from '@/api/proxyWeb/catalog'

export default {

    getAll({ commit }) {

        commit('setCatalog', null)

        return new Promise(resolve => {
        
            Promise.all([
                api.count(),
                api.list()
            ])
            .then( ([ count, articles ]) => {
                commit('setCount', count)
                commit('setCatalog', articles)
                resolve(articles)
            })
        })
    },

    getNext({ commit, state }) {

        const params = {
            page: state.page + 1 
        }
        
        return api.list(params)
            .then(articles => {
                commit('setNextArticles', articles)
            })
    } 
}